<template>
	<div v-loading="loading">
		<div class="app-container">
			<el-descriptions title="基本信息" :column="2" :size="size" border>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						企业名称
					</template>
					{{qydjjbxx.entname}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-connection"></i>
						统一社会信用代码
					</template>
					{{qydjjbxx.uniscid}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-document-checked"></i>
						注册号
					</template>
					{{qydjjbxx.regno}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-coordinate"></i>
						法定代表人
					</template>
					{{qydjjbxx.lerep}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-bank-card"></i>
						类型
					</template>
					{{selectDictLabel(enttypeOptions,qydjjbxx.enttype)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-date"></i>
						成立日期
					</template>
					{{ parseTime(qydjjbxx.estdate, '{y}年{m}月{d}日') }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-money"></i>
						注册资本
					</template>
					{{qydjjbxx.regcap}}万{{qydjjbxx.entcat==='8'?selectDictLabel(currencyOptions,qydjjbxx.regcapcur):''}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-date"></i>
						核准日期
					</template>
					{{ parseTime(qydjjbxx.apprdate, '{y}年{m}月{d}日') }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-s-check"></i>
						登记机关
					</template>
					{{selectDictLabel(regorgOptions,qydjjbxx.regorg)}}

				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-s-promotion"></i>
						登记状态
					</template>
					{{selectDictLabel(entstatusOptions,qydjjbxx.entstatus)}}

				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-place"></i>
						管辖机关
					</template>
					{{selectDictLabel(regorgOptions,qydjjbxx.localadm)}}

				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-notebook-2"></i>
						行业门类
					</template>
					{{selectDictLabel(industryphyOptions,qydjjbxx.industryphy)}}

				</el-descriptions-item>
				<el-descriptions-item span=2>
					<template slot="label">
						<i class="el-icon-location-outline"></i>
						住所
					</template>
					{{qydjjbxx.dom}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-office-building"></i>
						经营范围
					</template>
					{{qydjjbxx.busscope}}
				</el-descriptions-item>
			</el-descriptions>
			<!-- 财务负责人信息 -->
			<el-descriptions style="margin-top:10px" title="财务负责人信息" :column="2" :size="size" border>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						姓名
					</template>
					{{this.qydjcwfzrxx.name}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-phone"></i>
						电话
					</template>
					{{this.qydjcwfzrxx.tel}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-mobile-phone"></i>
						移动电话
					</template>
					{{this.qydjcwfzrxx.mobtel}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-message"></i>
						邮箱
					</template>
					{{this.qydjcwfzrxx.email}}
				</el-descriptions-item>
			</el-descriptions>
			<!-- 企业联络人信息 -->
			<el-descriptions style="margin-top:10px" title="联络人信息" :column="2" :size="size" border>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						姓名
					</template>
					{{this.qydjllrxx.name}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-phone"></i>
						电话
					</template>
					{{this.qydjllrxx.tel}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-mobile-phone"></i>
						移动电话
					</template>
					{{this.qydjllrxx.mobtel}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-message"></i>
						邮箱
					</template>
					{{this.qydjllrxx.email}}
				</el-descriptions-item>
			</el-descriptions>
			<div class="el-title">人员信息</div>
			<el-table v-loading="loading" border :data="ryxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50">
				</el-table-column>
				<!-- <el-table-column label="姓名" align="center" prop="name" ></el-table-column> -->
				<el-table-column label="职务" align="center" prop="position">
					<template slot-scope="scope">
						<el-tag :type="scope.$index==0?'success':'primary'">
							{{selectDictLabel(positionOptions,scope.row.position)}}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column label="是否法定代表人" align="center" prop="lerepsign">
					<template slot-scope="scope">
						<el-tag effect="dark" :type="scope.row.lerepsign == '1' ? 'primary' : 'info'">
							{{scope.row.lerepsign==='1'?'是':'否'}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="totalRyxx>0" :total="totalRyxx" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getQydjRyxxList" />
			<div class="el-title">出资信息</div>
			<el-table v-loading="loading" border :data="czxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50">
				</el-table-column>
				<el-table-column label="投资人姓名" align="center" prop="inv" />
				<el-table-column label="投资人类型" align="center" prop="invtype">
					<template slot-scope="scope">
						<el-tag :type="scope.$index==0?'success':'primary'">
							{{selectDictLabel(invtypeOptions,scope.row.invtype)}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="认缴出资额" align="center" prop="subconam" />
				<el-table-column label="出资方式" align="center" prop="conform">
					<template slot-scope="scope">
						{{selectDictLabel(conformOptions,scope.row.conform)}}
					</template>
				</el-table-column>
				<el-table-column label="出资比例(%)" align="center" prop="conprop">
					<template slot-scope="scope">
						<el-tag effect="dark" :type="scope.$index == '0' ? 'primary' : 'success'">
							{{scope.row.subconprop}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="totalCzxx>0" :total="totalCzxx" :page.sync="queryCzxxParams.pageNum"
				:limit.sync="queryCzxxParams.pageSize" @pagination="getQydjCzxxList" />
			<div class="el-title">变更备案记录</div>
			<el-table v-loading="loading" border :data="bgsxList" ref="tBgxx">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="变更时间" align="center" prop="altdate" width="120" />
				<el-table-column label="变更事项" align="center" prop="invtype" width="120">
					<template slot-scope="scope">
						{{selectDictLabel(altitemOptions,scope.row.altitem)}}
					</template>
				</el-table-column>
				<el-table-column label="变更前内容" align="center" prop="altbe" />
				<el-table-column label="变更后内容" align="center" prop="altaf" />
			</el-table>
			<pagination v-show="totalBgsx>0" :total="totalBgsx" :page.sync="queryBgxxParams.pageNum" :autoScroll=false
				:limit.sync="queryBgxxParams.pageSize" @pagination="getQydjBgsxList" />
		</div>
	</div>
</template>

<script>
	import {
		getQydjJbxx,
		listQydjRyxx,
		listQydjCzxx,
		listQydjBgsx,
		getQydjllrxxInfo,
		getQydjCwfzrxxInfo
	} from "@/api/qygzs/yqyd";

	export default {
		name: 'QydjJbxx',
		props: {
			//企业内部序号
			pripid: {
				type: String,
				require: true
			}
		},
		watch: {
			pripid(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				// 企业登记基本信息
				qydjjbxx: {},
				// 企业登记联络人信息
				qydjllrxx: {
					name:'',
					tel:'',
					mobtel:'',
					email:'',
				},
				// 企业登记财务负责人信息
				qydjcwfzrxx: {
					name:'',
					tel:'',
					mobtel:'',
					email:'',
				},
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【人员信息】总条数
				totalRyxx: 0,
				// 【人员信息】表格数据
				ryxxList: [],
				//【出资信息】总条数
				totalCzxx: 0,
				// 【出资信息】表格数据
				czxxList: [],
				//【变更备案信息】总条数
				totalBgsx: 0,
				// 【变更备案信息】表格数据
				bgsxList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},
				queryCzxxParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},
				queryBgxxParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},
				size: 'medium ',
				//企业类型字典
				enttypeOptions: [],
				//币种字典
				currencyOptions: [],
				// 登记机关字典
				regorgOptions: [],
				//企业状态字典
				entstatusOptions: [],
				// 行业门类
				industryphyOptions: [],
				// 行业代码
				industrycoOptions: [],
				//人员职务字典
				positionOptions: [],
				//投资人类型字典
				invtypeOptions: [],
				//出资方式字典
				conformOptions: [],
				//变更事项字典
				altitemOptions: []


			}
		},
		created() {
			this.init();
			this.getDicts("fdw_ENTTYPE").then(response => {
				this.enttypeOptions = response.data;
			});
			this.getDicts("fdw_CURRENCY").then(response => {
				this.currencyOptions = response.data;
			});
			this.getDicts("fdw_CASEFIAUTH").then(response => {
				this.regorgOptions = response.data;
			});
			this.getDicts("fdw_ENTSTATUS").then(response => {
				this.entstatusOptions = response.data;
			});
			this.getDicts("fdw_INDUSTRYPHY").then(response => {
				this.industryphyOptions = response.data;
			});
			/* this.getDicts("fdw_INDUSTRYCO").then(response => {
			   this.industrycoOptions = response.data;
			 }); */
			this.getDicts("fdw_POSITION").then(response => {
				this.positionOptions = response.data;
			});
			this.getDicts("fdw_INVTYPE").then(response => {
				this.invtypeOptions = response.data;
			});
			this.getDicts("fdw_CONFORM").then(response => {
				this.conformOptions = response.data;
			});
			this.getDicts("fdw_ALTITEM").then(response => {
				this.altitemOptions = response.data;
			});



		},

		methods: {
			init() {
				this.qydjjbxx = {},
				this.loadQydjJbxx();
				this.getQydjRyxxList();
				this.getQydjCzxxList();
				this.getQydjBgsxList();
				this.loadQydjCwfzrxx();
				this.loadQydjLlrxx();
				this.loading = true;
			},
			//获取企业基本信息
			loadQydjJbxx() {
				getQydjJbxx(this.pripid).then(response => {
					this.qydjjbxx = response.data;
					this.loading = false;
				});
			},
			//获取企业联络人信息
			loadQydjLlrxx() {
				getQydjllrxxInfo(this.pripid).then(response => {
					// console.log(response)
					this.qydjllrxx = response.data;
					this.loading = false;
				});
			},
			//获取企业财务负责人人信息
			loadQydjCwfzrxx() {
				getQydjCwfzrxxInfo(this.pripid).then(response => {
					// console.log('sss',response)
					this.qydjcwfzrxx = response.data;
					this.loading = false;
				});
			},
			// 获取人员信息
			getQydjRyxxList() {
				this.loading = true;
				this.queryParams.pripid = this.pripid;
				listQydjRyxx(this.queryParams).then(response => {
					this.ryxxList = response.rows;
					this.totalRyxx = response.total;
					this.loading = false;
				});
			},
			// 获取出资信息
			getQydjCzxxList() {
				this.loading = true;
				this.queryCzxxParams.pripid = this.pripid;
				listQydjCzxx(this.queryCzxxParams).then(response => {
					this.czxxList = response.rows;
					this.totalCzxx = response.total;
					this.loading = false;
				});
			},
			// 变更信息
			getQydjBgsxList() {
				this.loading = true;
				this.queryBgxxParams.pripid = this.pripid;
				listQydjBgsx(this.queryBgxxParams).then(response => {
					this.bgsxList = response.rows;
					this.totalBgsx = response.total;
					this.loading = false;


				});

			},

		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
